module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Password reset","description":"Forgot your password? You can reset it here."},"title":"Reset password","newPassword":"New password","submit":"Reset my password","login":"Login"}}')
  delete Component.options._Ctor
}
